import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import React from 'react';
import { useDropdownContext } from './context';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'dropdown',
  element: 'menu'
});
export var DropdownMenu = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'ul' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "children"]);

  var _useDropdownContext = useDropdownContext(),
      hidden = _useDropdownContext.hidden;

  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    tabIndex: -1,
    role: "menu",
    "aria-labelledby": "menubutton",
    sx: {
      variant: variantPath(hidden ? 'hidden' : 'base'),
      userSelect: 'none'
    }
  }, props), {}, {
    children: children
  }));
});
DropdownMenu.displayName = 'DropdownMenu';